// function __export(m) {
//     for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
// }
exports.MultipleDatePickerModule = require('./dist/multiple-date-picker.module').MultipleDatePickerModule;

// // exports.MultipleDatePickerModule = require('./dist/multiple-date-picker.module').MultipleDatePickerModule;

// exports.printMsg = function() {
//   // // console.log("This is a message from the index.js file -- edit as needed");
// };

